<template>
  <div>
    <div class="card-container position-relative row mt-5 fade-opacity">
      <div
        v-for="(list, index) in faq"
        :key="index"
        class="col-12 col-md-6 p-3"
      >
        <div class="card-item">
          <h2 class="card-title">{{ list.title }}</h2>
          <p class="card-description" style="color: #f0f0f0;">
            {{ list.description }}
          </p>
        </div>
      </div>
      <div class="fade-out-overlay"></div>
    </div>
    <div class="w-100 d-flex jusify-content-center mt-5">
      <button @click="navigateToFaq" class="faq-button">Tampilkan Semua FAQ</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardFaq",
  props: {
    faq: {
      type: Array,
      required: true,
    },
  },
  methods: {
    navigateToFaq(){
      this.$router.push('/faq')
    }
  }
};
</script>

<style scoped>
.card-title {
  color: #fff;
  font-size: 20px;
  border-bottom: 1px solid #b3b3b3;
  padding-bottom: 20px;
  text-transform: capitalize;
  letter-spacing: 0;
  font-weight: 600;
}
.card-description {
  padding-top: 20px;
  color: #f0f0f0;
  font-size: 18px;
  text-align: justify;
}
.faq-button {
  background-color: #13346c;
  border: none;
  border-radius: 100px;
  color: white;
  padding: 18px 20px;
  font-weight: 600;
  margin: auto;
  transition: all 0.3s;
}
.faq-button:hover {
  scale: 105%;
}
.faq-button:active {
  scale: 95%;
}
.fade-opacity {
  /* Mask pakai gradient */
  -webkit-mask-image: linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0));
  mask-image: linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0));

  /* Biar smooth */
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;

  /* Pastikan konten kelihatan */
  color: white;
}

.container {
  max-width: 90%;
}

@media (max-width: 767px) {
  .card-item {
    padding: 20px;
    border: 1px solid #b3b3b3;
    border-radius: 14px;
    height: 100%;
  }
}

@media (min-width: 768px) {
  .card-item {
    padding: 20px;
    border: 1px solid #b3b3b3;
    border-radius: 14px;
    height: 100%;
  }
}

@media (min-width: 1025px) {
  .card-item {
    padding: 50px;
    border: 1px solid #b3b3b3;
    border-radius: 14px;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing-page/cardFaq.vue